export const FORM_ITEMS = {
  PASSWORD_RULES_BLOCK_ID: 'passwordRulesBlock',
  ERROR_CONTAINER_ID: 'errorTextContainer',
  ERROR_CONTAINER_ACCOUNT_EMAIL_ID: 'errorTextContainerAccountEmail',
  BASIC_ERROR_TEXT: 'An error occurred. Please, try again later.',
};
